<template>
  <div class="EVEN">
    <div
        @click.prevent="openPdf(item)"
        class="d-flex jc-between cur-pointer p-b-2"
    >
      <div class="h5 text-bold c-gray70 p-l-6 m-t-2">
        <img src="../assets/pdf.svg" alt="pdf"/> {{item.title}}
      </div>
      <span class="LINER"/>
    </div>
  </div>
</template>
<script>

export default {
  name: 'resource-item',
  props: {
    item: {
      type: Object,
      default () { return {}; },
    },
  },
  data () {
    return {
      isOpen: false,
      isVisible: false,
      showSpinner: false,
    };
  },
  methods: {
    onClick () {
      if (this.isOpen) {
        this.isVisible = false;
        setTimeout(() => {
          this.isOpen = false;
        }, 400);
      } else {
        this.showSpinner = true;
        this.isOpen = true;
        setTimeout(() => {
          this.isVisible = true;
          this.showSpinner = false;
        }, 2000);
      }
    },
    openPdf (item) {
      this.$events.$emit(this.$events.RESOURCE_OPEN_PDF, { pdfTitle: item.title });
      window.open(item.pdf, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";
.EVEN {
  background-color: white;
}
.ARROW {
  margin: 10px 12px 5px 0px;
  color: $color-gray80;
}
.SUB-SECTION {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  transition: opacity 1.0s ease-in-out;
  opacity: 1;
}
.CLOSED-SUB-SECTION {
  display: flex;
  justify-content: center;
  transition: opacity 1.0s ease-in-out;
  opacity: 0;
}
</style>
